// src/pages/api/admin/PlansMainPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../../Components/admin/adminLayout";

export default function PlansMainPage() {
  const navigate = useNavigate();

  return (
    <AdminLayout>
      <h2 style={{ marginBottom: "20px" }}>Manage Plans</h2>

      <div
        style={{
          display: "flex",
          gap: "40px",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "60px",
        }}
      >
        {/* Seller Plans Tile */}
        <div
          onClick={() => navigate("/admin/plans/seller")}
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "40px 60px",
            cursor: "pointer",
            textAlign: "center",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.05)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
        >
          <h3>Seller Plans</h3>
          <p>
            Manage plans for sellers — control post visibility, pricing, and
            duration.
          </p>
        </div>

        {/* Buyer Plans Tile */}
        <div
          onClick={() => navigate("/admin/plans/buyer")}
          style={{
            background: "#fff",
            borderRadius: "10px",
            padding: "40px 60px",
            cursor: "pointer",
            textAlign: "center",
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            transition: "all 0.3s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.05)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
        >
          <h3>Buyer Plans</h3>
          <p>
            Manage plans for buyers — control contact visibility and plan
            validity.
          </p>
        </div>
      </div>
    </AdminLayout>
  );
}
